var _rect, _g, _path, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendChatTranscrptIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Send_chat_transcrpt",
    "data-name": "Send chat transcrpt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1831",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reader-outline",
    transform: "translate(0.889 0.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1832",
    d: "M9.889,15.359H2.778A1.87,1.87,0,0,1,1,13.412V2.737A1.87,1.87,0,0,1,2.778.79H9.889a1.87,1.87,0,0,1,1.778,1.947v8.578",
    transform: "translate(-1 -0.79)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu-outline",
    d: "M3.93,5.23H9.379M3.93,7.523H9.379M3.93,9.817H9.379",
    transform: "translate(-0.437 -0.581)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "return-down-forward-outline",
    transform: "translate(6.222 11.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    d: "M15.78,16.059,17.1,14.734,15.78,13.41",
    transform: "translate(-7.976 -13.054)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    d: "M15.8,14.681H9.329c-1.3,0-2.329-.64-2.329-1.413V13.01",
    transform: "translate(-7 -13.01)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChatTranscrptIcon);
export default __webpack_public_path__ + "static/media/send-chat-transcrpt-icon.e6a5e9274cf1cec9bf1e37b163cd4ec8.svg";
export { ForwardRef as ReactComponent };